<template>
  <div>
    <div class="header">
      <p>Welcome to</p>
      <h1>
        <b>Experiments</b>
      </h1>
      <p>The first
      <b>online social experiment platform</b>, where everyone can
      participate.</p>
    </div>

    <div class="banner">
      <h3>95% of our decision-making takes place on subconscious level <br> <b>
How much does it influence yours?</b></h3>
    </div>

    <p class="paragraph">
      Find out in this 1-minute experiment and learn how you are influenced without knowing it.
    </p>

    <bg-button
      class="button"
      @click="$router.push({ name: 'steptwo' })"
      text="Start the experiment!"
    ></bg-button>

    <p style="margin-top: 25px">
      <b>Braingineers</b>: Unlocking emotional experience
    </p>

  </div>
</template>

<style scoped>

p, h1, li {
  color: #0A0D3D;
}

.header {
  margin-bottom: 40px;
}

h1 {
  font-size: 40pt;
  margin-top: 5px;
  margin-bottom: 20px;
}

.banner {
  padding: 30px 50px;
  background-color: #F1C40F;
  text-align: center;
  margin-bottom: 20px;
}

.paragraph {
  margin-bottom: 10px;
}
.button {
  margin-top: 20px;
}
.ul {
  margin-top: 40px;
}
</style>

<script>
import BgButton from "../components/bg-button";
export default {
  name: "App",
  components: {
    BgButton
  },
  computed: {
    price() {
      return this.$store.state.price;
    }
  }
};
</script>
